// import applyCaseMiddleware from 'axios-case-converter';
import axios, { AxiosResponse } from 'axios';
// @ts-ignore
import router from '@/router/router';
import get from 'lodash/get';
import store from '@/store';

// const caseOptions = {
//   preservedKeys: (input: string) => {
//     const UUIDRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
//
//     return UUIDRegex.test(input);
//   },
// };
// const http = applyCaseMiddleware(axios.create(), caseOptions);
const http = axios.create();

const requestQueue = new Map();

http.interceptors.request.use(async (request) => {
  const existRequest = requestQueue.get(request.url);
  const dataRequest = JSON.stringify(request.data);
  const dataExistRequest = JSON.stringify((existRequest || {}).data);
  const isFormData = request.data instanceof FormData;

  if (existRequest && (dataRequest === dataExistRequest) && !isFormData) {
    return {
      ...request,
      cancelToken: new axios.CancelToken((cancel) => cancel(`Cancel repeated request ${existRequest.url}`)),
    };
  }

  requestQueue.set(request.url, request);

  if (!request?.headers?.skipRenew) {
    const expireDate = store.state.user.expireToken;
    const diff = expireDate - new Date().getTime();
    let refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken) {
      refreshToken = sessionStorage.getItem('refreshToken');
    }

    if (diff <= 0 && refreshToken) {
      await store.dispatch('user/renew');
    }
  }

  let accessToken = localStorage.getItem('accessToken');

  if (!accessToken) {
    accessToken = sessionStorage.getItem('accessToken');
  }

  if (accessToken) {
    // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    request.headers.Authorization = `Bearer ${accessToken}`;
  }

  return request;
});

http.interceptors.response.use((response) => {
  requestQueue.delete(response.config.url);

  return response;
}, (error) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const isAuthRoute = router.currentRoute.value.name === 'Auth';
  const errorResponse = error.response || error;
  const unAuthCodes = [11, 403, 423, 22];
  const unAuth = (auth = false) => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    if (auth) router.push({ name: 'Auth', query: { from: window.location.pathname } });
    setTimeout(() => window.location.reload(), 500);
  };

  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (errorResponse.status !== 401 && !isAuthRoute) {
    const message1 = get(errorResponse, 'data.message');
    const message2 = get(errorResponse, 'message');
    const message3 = get(errorResponse, 'statusText');

    console.log(message1 || message2 || message3);

    // store.dispatch('errors/setError', { text: message1 || message2 || message3, isActive: true });
  }

  if (errorResponse.status === 400 && unAuthCodes.indexOf(errorResponse.data.code) !== -1) {
    unAuth(true);
  }

  if (errorResponse.status === 401 && !isAuthRoute) {
    unAuth(true);
  }

  if (errorResponse.config) {
    requestQueue.delete(errorResponse.config.url);
  }

  return Promise.reject(error);
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface HttpPromise<T = any> extends Promise<AxiosResponse<T>> {
  code?: string;
}

export default http;
